"use strict";

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var MultiSessionData = require('./MultiSessionData');

var MultiSessionTempData = require('./MultiSessionTempData');

var MultiSession =
/*#__PURE__*/
function () {
  function MultiSession() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'multi_session';

    _classCallCheck(this, MultiSession);

    this.key = key;
  }

  _createClass(MultiSession, [{
    key: "ensure",
    value: function ensure() {
      if (typeof localStorage === 'undefined' || typeof sessionStorage === 'undefined') throw new Error('Browser should support localStorage and sessionStorage.');
    }
  }, {
    key: "load",
    value: function load() {
      this.ensure();
      var obj = {
        key: this.key,
        currentName: '',
        accounts: {}
      };
      var data = localStorage.getItem(this.key);

      if (data) {
        try {
          data = new Buffer(data, 'hex').toString();
          data = JSON.parse(data);
          if (data.currentName) obj.currentName = data.currentName;
          if (data.accounts) obj.accounts = data.accounts;
        } catch (err) {
          console.warn('MultiSession.load', err);
        }
      }

      return new MultiSessionData(obj);
    }
  }, {
    key: "loadTemp",
    value: function loadTemp() {
      this.ensure();
      var obj = {
        key: this.key,
        accounts: {}
      };
      var data = sessionStorage.getItem(this.key);

      if (data) {
        try {
          data = new Buffer(data, 'hex').toString();
          data = JSON.parse(data);
          if (data.accounts) obj.accounts = data.accounts;
        } catch (err) {
          console.warn('MultiSession.loadTemp', err);
        }
      }

      return new MultiSessionTempData(obj);
    }
  }, {
    key: "clearExpired",
    value: function clearExpired() {
      var _this$loadTemp;

      this.ensure();
      return (_this$loadTemp = this.loadTemp()).clearExpired.apply(_this$loadTemp, arguments).save();
    }
  }, {
    key: "logout",
    value: function logout(account) {
      var newCurrent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      this.loadTemp().logout(account).save();
      return this.load().logout(account, newCurrent).save();
    }
  }, {
    key: "clear",
    value: function clear() {
      this.loadTemp().clear().save();
      return this.load().clear().save();
    }
  }]);

  return MultiSession;
}();

module.exports = MultiSession;